import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-object-type',
  template: `
    <p-divider
      *ngIf="
        props && props.attributes && props.attributes['separator']
      "
    ></p-divider>
    <div class="field p-fluid mb-3 mt-1">
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label class="block">{{ field.templateOptions.label }}</label>
      <div
        *ngIf="
          field.templateOptions.description &&
          (!showError || !formControl.errors)
        "
        class="text-sm my-2"
      >
        {{ field.templateOptions.description }}
      </div>
      <formly-field
        *ngFor="let f of field.fieldGroup"
        [field]="f"
      ></formly-field>
      <div
        *ngIf="showError && formControl.errors"
        class="text-sm mt-2 p-error"
      >
        <formly-validation-message
          [field]="field"
        ></formly-validation-message>
      </div>
    </div>
  `,
})
export class ObjectTypeComponent extends FieldType {}
